import styled from "styled-components";
import { useEffect, useState } from "react";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";
import { CashPendingPayment } from "../../../types/common.types";

interface PendingPaymentsProps {
    day?: Date
    endDay?: Date
}

export default function PendingPayments({ day, endDay }: PendingPaymentsProps) {
    const { setIsLoading } = useGlobal()
    const { setIsCreatePendingPaymentModalOpen, setCreateCashMovementPrefill, setIsCreateCashMovementModalOpen, setEditPendingPaymentData, setConfirmDeletePendingPaymentId } = useAdmin()
    const [pendingPayments, setPendingPayments] = useState<CashPendingPayment[]>([])

    useEffect(() => {
        async function load() {
            setIsLoading(true)
            try {
                const res = await AdminService.listCashPendingPayments('open', undefined, day, endDay)
                setPendingPayments(res.data)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        load()
    }, [setIsLoading, day, endDay])

    function registerAbono(pp: CashPendingPayment) {
        // Un pago pendiente de aliado es un ingreso (el aliado nos paga); los demás, egresos.
        setCreateCashMovementPrefill({ pending_payment_id: pp.id, category_id: pp.category_id, counterpart_name: pp.counterpart_name, movement_type: pp.category?.flow_type || 'egreso' })
        setIsCreateCashMovementModalOpen(true)
    }

    return (
        <Main>
            <div className="header">
                <h3>Pagos pendientes</h3>
                <button type="button" onClick={() => setIsCreatePendingPaymentModalOpen(true)}>+ Nuevo</button>
            </div>
            {pendingPayments.length === 0 && <p className="empty">No hay pagos pendientes abiertos</p>}
            {pendingPayments.map(pp => (
                <div className="row" key={pp.id}>
                    <div className="info">
                        <span className="name">{pp.counterpart_name}</span>
                        <span className="category">{pp.category?.name}</span>
                    </div>
                    <div className="amounts">
                        <span>Total: ${pp.total_amount.toLocaleString('es-CL')}</span>
                        <span>Pagado: ${pp.paid_amount.toLocaleString('es-CL')}</span>
                        <span className="balance">Saldo: ${(pp.total_amount - pp.paid_amount).toLocaleString('es-CL')}</span>
                    </div>
                    <div className="row-actions">
                        <button type="button" onClick={() => registerAbono(pp)}>Registrar abono</button>
                        <button type="button" className="edit" onClick={() => setEditPendingPaymentData(pp)}>Editar</button>
                        <button type="button" className="delete" onClick={() => setConfirmDeletePendingPaymentId(pp.id)}>Eliminar</button>
                    </div>
                </div>
            ))}
        </Main>
    )
}

const Main = styled.div`
margin: 20px 0;
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    h3 { font-size: 16px; }
    button {
        padding: 6px 12px;
        border-radius: 6px;
        border: 2px solid ${props => props.theme.yellowDark};
        background: ${props => props.theme.yellowDark};
        color: ${props => props.theme.white};
        cursor: pointer;
    }
}
.empty {
    color: ${props => props.theme.gray};
    font-size: 14px;
}
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    border-radius: 8px;
    background: ${props => props.theme.whiteBackground};
    margin-bottom: 8px;
    flex-wrap: wrap;
    .info {
        display: flex;
        flex-direction: column;
        .name { font-weight: 600; }
        .category { font-size: 12px; color: ${props => props.theme.gray}; }
    }
    .amounts {
        display: flex;
        flex-direction: column;
        font-size: 12px;
        .balance { font-weight: 700; }
    }
    .row-actions {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }
    .row-actions button {
        padding: 8px 12px;
        border-radius: 6px;
        border: 2px solid ${props => props.theme.blue};
        background: transparent;
        color: ${props => props.theme.blue};
        cursor: pointer;
    }
    .row-actions button.edit {
        border-color: ${props => props.theme.gray};
        color: ${props => props.theme.gray};
    }
    .row-actions button.delete {
        border-color: ${props => props.theme.red};
        color: ${props => props.theme.red};
    }
}
`
